import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../../api';

// Importar seus componentes de UI
import Header from '../../components/layout/Header';
import { Button } from '../../components/common/Button';
import { FormGroup, Label, Input, Message } from '../../components/common/Forms';
import { AuthPageContainer, AuthFormCard, Title, SubtitleLink } from '../../components/common/AuthLayout';

function RecuperarSenhaPage() {
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState({ text: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMensagem({ text: '', type: '' });

    try {
      const response = await apiClient.post('/api/solicitar-recuperacao', { email });
      // Sempre mostramos sucesso, por segurança (evitar enumeração de e-mail)
      setMensagem({ text: response.data.message, type: 'success' });
    } catch (error) {
      // Mesmo em erro, mostramos a mensagem de sucesso genérica
      setMensagem({
        text: 'Se uma conta com este e-mail existir, um link de recuperação foi enviado.',
        type: 'success'
      });
    } finally {
      setIsLoading(false);
      setEmail(''); // Limpa o campo
    }
  };

  return (
    <>
      <Header />
      <AuthPageContainer>
        <AuthFormCard>
          <Title>Recuperar Senha</Title>
          <p style={{ textAlign: 'center', marginTop: '-1.5rem', marginBottom: '1.5rem' }}>
            Digite seu e-mail e enviaremos um link para redefinir sua senha.
          </p>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="email">Email:</Label>
              <Input 
                id="email"
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                type="email" 
                required 
                placeholder="seu@email.com"
              />
            </FormGroup>

            {/* Mensagem de sucesso/erro */}
            {mensagem.text && 
              <Message type={mensagem.type} style={{marginBottom: '1rem'}}>
                {mensagem.text}
              </Message>
            }

            <Button type="submit" style={{ width: '100%' }} disabled={isLoading}>
              {isLoading ? 'Enviando...' : 'Enviar Link'}
            </Button>
          </form>

          <SubtitleLink>
            Lembrou a senha? <Link to="/login">Voltar ao Login</Link>
          </SubtitleLink>
        </AuthFormCard>
      </AuthPageContainer>
    </>
  );
}

export default RecuperarSenhaPage;